import { render, staticRenderFns } from "./detalhesPedidoVenda.vue?vue&type=template&id=c106a842&scoped=true&"
import script from "./detalhesPedidoVenda.vue?vue&type=script&lang=js&"
export * from "./detalhesPedidoVenda.vue?vue&type=script&lang=js&"
import style0 from "./detalhesPedidoVenda.vue?vue&type=style&index=0&id=c106a842&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c106a842",
  null
  
)

export default component.exports